import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class SidenavItemComponent {
  activeItem: boolean = false;
  marginLeft: boolean = false;
  colorText: string = 'color-primary-500';
  typeItem: string | null = null;
  hoverItem: boolean = false;

  @Input() title: string | null = null;
  @Input() set active(active: boolean) {
    this.activeItem = active;
    this.colorText = active ? 'color-white' : 'color-primary-500';
  }

  @Input() set type(type: string) {
    if (type === 'back') {
      this.typeItem = 'back';
    }
  }

  @Output() back: EventEmitter<any> = new EventEmitter();

  @HostListener('mousedown') onMouseDown() {
    if (this.activeItem) {
      this.colorText = 'color-white';
    }
    if (!this.activeItem && this.typeItem !== 'back') {
      this.colorText = 'color-white';
    }
  }

  @HostListener('mouseup') onMouseUp() {
    if (this.activeItem) {
      this.colorText = 'color-white';
    }
    if (!this.activeItem && this.typeItem !== 'back') {
      this.colorText = 'color-primary-500';
    }
  }

  @HostListener('mouseover') onMouseOver() {
    if (!this.activeItem) {
      this.hoverItem = true;
    }
  }

  @HostListener('mouseout') onMouseOut() {
    if (!this.activeItem) {
      this.hoverItem = false;
    }
  }

  slotChange($event) {
    const assigned = $event.target.assignedNodes();
    if (assigned.length > 0) {
      this.marginLeft = true;
    }
  }

  onClickBack() {
    this.back.emit();
  }
}
